import axios from 'axios';
import { removeWorkSpaceFromLS } from 'helpers/functions/workspaceHelpers';
import { AppStore } from 'store/store';
import { workspaceSlice } from 'store/workspace/slice';
import { maintenanceSlice } from 'store/maintenance/slice';
// import Cookies from 'js-cookie';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

export const applyInterceptors = (store: AppStore) => {
  api.interceptors.request.use(
    (config) => {
      return config;
    }
  )
  
  api.interceptors.response.use(
    (config) => {
      store.dispatch(maintenanceSlice.actions.resetErrorCount());
      return config;
    },
    async (error) => {
      const state = store.getState()
      
      // Check if it's a connection refused error
      // if (!error.response && error.message === 'Network Error') {
      //   store.dispatch(maintenanceSlice.actions.setMaintenanceMode(true));
      //   return Promise.reject(error);
      // }

      if(error?.response?.status === 401) {
        localStorage.removeItem('user');
        localStorage.removeItem('mfaVerified');
        removeWorkSpaceFromLS()
        state.userStateSlice.isSignedIn === true && window.location.reload();
        error.suppressNotification = true;
        return;
      }
      else if(error?.response?.status === 422) {
          // Read-only workspace violation
          const ownerEmail = error?.response?.data?.ownerEmail || '';
          const message = ownerEmail 
              ? `This is a read-only workspace, and therefore cannot be edited.\n\nThis workspace is owned by ${ownerEmail}`
              : 'This is a read-only workspace, and therefore cannot be edited.';
          store.dispatch(workspaceSlice.actions.handleRestrictionPopup({open: true, message}))
          return error.response
      }
      else if(error?.response?.status === 423) {
          store.dispatch(workspaceSlice.actions.handleRestrictionPopup({open: true, message: 'Another user is currently working on the workspace.'}))
          return error.response
      }
      else if(error?.response?.status === 403) {
        const state = store.getState()
        const selectedTab = state.workspaceSlice.tabs.find(item=>item.isSelected)
        if(selectedTab?.type === 4 && window.location.pathname.includes('/Explore')){
          store.dispatch(workspaceSlice.actions.handleRestrictionPopup({open: true, message: 'Sorry, you are not authorized to view a Data Grid tab. Please contact your company administrator for further assistance.'}))
        }
      } 
      else if(error?.response?.status === 405) {
          // store.dispatch(workspaceSlice.actions.handleRestrictionPopup({open: true, message: 'Bad request. Please check your service'}))
          return ;
      }
      return Promise.reject(error);
  })
}

api.defaults.headers.common['content-type'] = 'application/json'
